<template>
    <div class="bottom-list-wrap" >
        <div v-if="all_questions!==undefined">
            <router-view :all_questions="all_questions"> 
            </router-view>
            <!-- :key="$route.fullPath" -->

        </div>
        
    </div>
</template>
<script>


export default {

    data(){
        return {
            test: ""
        }
    },
    props: ['all_questions']

}
</script>



// WEBPACK FOOTER //
// src/Qna/list.vue